import Vue from 'vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import VueSimpleSpinner from 'vue-simple-spinner';
import CheckboxControl from './components/CheckboxControl.vue';
import 'vue-loaders/dist/vue-loaders.css';
import {BallPulseLoader} from 'vue-loaders';
import Fragment from 'vue-fragment';
import Notifications from "vue-notification";
import NotifyPlugin from "@/plugins/NotifyPlugin";
import App from "@/App.vue";
import smoothscroll from "smoothscroll-polyfill";

Vue.config.productionTip = false;
smoothscroll.polyfill();
Vue.use(Notifications);
Vue.use(NotifyPlugin);
// Plugin to hack around Vue's limitation that each component must have a single root element.
// Sometimes we want a component to contain multiple elements that should all pretend to be "root" elements
// so they can play nice with their grandparent's (the component's parent) styling (e.g. in CSS Gridbox)
Vue.use(Fragment.Plugin);

Vue.component(flatPickr.name, flatPickr);
Vue.component('checkbox-control', CheckboxControl);
Vue.component('vue-simple-spinner', VueSimpleSpinner);
Vue.component(BallPulseLoader.name, BallPulseLoader);

Vue.config.ignoredElements = [/^ion-/]

// Global mixins aren't ideal but in this case it will do the job nicely
Vue.mixin({
    data () {
        return {
            globalFlatpickrConfig: {
                allowInput: true,
                altInput: true,
                altFormat: 'm/d/Y',
                locale: {
                    'firstDayOfWeek': 0 // start week on Sunday
                },
                dateFormat: 'Z',
                disableMobile: true,
                onClose: function (selectedDates:any, dateStr:any, instance:any) {
                    // This sets the date to what is in the input box when tabbing off of the date.
                    instance.setDate(instance._input.value, true, instance.config.altFormat);
                },
            }
        };
    }
});

new Vue({
    el: '#custom-form-app',
    render: (h) => h(App),
}).$mount('#custom-form-app');
